module.exports = __webpack_public_path__ + "img/logo_JP.f418ef49.png";